import { useEffect } from 'react';
import useCardBackupModals from 'hooks/useCardBackupModals';
import { showCreditCardNotificationModal } from 'stores/modal';
import { useDispatch } from 'react-redux';

const CardNotificationModal = () => {
  const dispatch = useDispatch();
  const { notificationData, primaryCard, backupCard, loading, hasShownModal } =
    useCardBackupModals();

  // Automatically show modal when notifications are loaded
  useEffect(() => {
    if (
      notificationData &&
      notificationData?.notifications &&
      notificationData?.notifications?.Id &&
      !loading &&
      !hasShownModal.current &&
      notificationData?.IsDiscountAvailable
    ) {
      hasShownModal.current = true;
      dispatch(showCreditCardNotificationModal(notificationData));
    }
  }, [notificationData, primaryCard, backupCard, loading, dispatch]);

  return null;
};

export default CardNotificationModal;
